const API_BASE = import.meta.env.VITE_API_BASE || "/api";

export const downloadFile = (url: string, filename?: string) => {
  console.log("API_BASE", API_BASE, `${API_BASE}${url}`);
  fetch(`${API_BASE}${url}`)
    .then((response) => {
      const contentDisposition = response.headers.get("Content-Disposition");
      const finalFilename =
        filename ||
        (contentDisposition
          ? decodeURIComponent(contentDisposition.split("filename=")[1].replace(/"/g, ""))
          : `download_${new Date().toISOString().split("T")[0]}`);

      return response.blob().then((blob) => ({ blob, filename: finalFilename }));
    })
    .then(({ blob, filename }) => {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    });
};
